import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const ashbyWeb: PluginWebManifest = {
  orgSetupComponent: {
    componentPath: '@reflex/plugin-ashby/web/AshbyPage',
    label:
      'Add an Ashby API key so this org can read candidate and job data through Reflex MCP tools.',
  },
  marketingPreviews: [
    {
      id: 'ashby-page',
      label: 'Ashby integration page',
      description:
        'Connected Ashby account with team-level access controls, webhook URL, and recent verified webhook deliveries. Sample data only.',
      surface: 'page',
      componentPath: '@reflex/plugin-ashby/web/AshbyPagePreview',
    },
  ],
};
